import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <g transform="translate(16, 23) scale(0.8)">
          <path
            d="M0 45.26L0 9.47L13.50 9.47Q17.07 9.47 18.95 9.81Q21.58 10.25 23.36 11.49Q25.15 12.72 26.23 14.94Q27.32 17.16 27.32 19.82Q27.32 24.39 24.41 27.55Q21.51 30.71 13.92 30.71L4.74 30.71L4.74 45.26L0 45.26M4.74 26.49L13.99 26.49Q18.58 26.49 20.51 24.78Q22.44 23.07 22.44 19.97Q22.44 17.72 21.30 16.13Q20.17 14.53 18.31 14.01Q17.11 13.70 13.89 13.70L4.74 13.70L4.74 26.49ZM43.58 45.26L29.71 9.47L34.84 9.47L44.14 35.47Q45.26 38.60 46.02 41.33Q46.85 38.40 47.95 35.47L57.62 9.47L62.45 9.47L48.44 45.26L43.58 45.26Z"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default IconLogo;
